import styled from "styled-components";
import { Link } from "react-router-dom";

const Image = styled.img`
  height: 300px;
  width: 100%;
  object-fit: cover;
  margin: auto 0;
`;

const ListTitle = styled.div`
  flex: 1;
  flexwrap: wrap;
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.haveImage ? "flex-start" : "center")};
  justify-content: ${(props) => (props.haveImage ? "flex-start" : "center")};
  height: ${(props) => (props.haveImage ? null : "120px")};
`;

const ListHeaderTitle = styled.div`
  color: ${(props) =>
    props.app_home_list_item_title_color
      ? props.app_home_list_item_title_color
      : "black"};
  padding-bottom: 6px;
  font-size: 16px;
`;

const ListSubTitle = styled.div`
  color: ${(props) =>
    props.app_home_list_item_subtitle_color
      ? props.app_home_list_item_subtitle_color
      : "gray"};
  font-weight: normal;
  line-height: 1.5em;
  height: 3em;
  overflow: hidden;
  margin: ${(props) => (props.category_img ? "0px" : "0 28px")};
  text-align: ${(props) => (props.category_img ? "left" : "center")};
  font-size: 14px;
`;

const StyledLink = styled(Link)`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const StyledA = styled.a`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const ImageStyle = styled.img`
  width: 120px;
  height: 120px;
  object-fit: cover;
`;

const TopPadding = styled.div`
  height: 5rem;
`;

const TitleLoading = styled.div`
  color: black;
  text-align: center;
  position: fixed;
  top: 50%;
  left: calc(50% - 36px);
`;

const BorderBottom = styled.div`
  border-bottom: ${(props) =>
    props.thickness
      ? props.thickness + "px solid #e3e3e3"
      : "2px solid #e3e3e3"};
  margin: ${(props) => (props.haveImage ? "0 16px 0 136px" : "0 28px")};
`;

const BoxLanguage = styled.div`
  position: fixed;
  right: 20px;
  bottom: 20px;
  height: 56px;
  width: 56px;
  background-color: rgba(0, 0, 0, 0.11);
  border-radius: 30px;
`;

export {
  Image,
  ListTitle,
  ListHeaderTitle,
  ListSubTitle,
  StyledLink,
  ImageStyle,
  TopPadding,
  TitleLoading,
  BorderBottom,
  BoxLanguage,
  StyledA,
};
